<template>
    <div>
        <el-form label-width="100px">
            <el-form-item label="文档:">
                <span>{{showMes.title}}</span>
                <span class="preview" @click="previewEvent(showMes)">预览</span>
            </el-form-item>
            <el-form-item label="文档编码:">
                <span>{{showMes.serialNumber}}</span>
            </el-form-item>
            <el-form-item label="文档状态:">
                <span>{{showMes.status}}</span>
            </el-form-item>
            <el-form-item label="描述:">
                <span>{{showMes.description}}</span>
            </el-form-item>
            <el-form-item label="版本:">
                <span>{{showMes.version}}</span>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onCancel">关闭</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "./event.service";
    export default {
        props:{
            id:{
                type:String|Number,
            }
        },
        data() {
            return {
                showMes:{},
            }
        },
        created() {
            this.getDetail();
        },
        methods:{
            getDetail(){
                services.getDocDetail({id:this.id}).then(res=>{
                    this.showMes = res;
                })
            },
            previewEvent(row){
                this.$router.push({
                    name:'Preview',
                    path:'/preview',
                    query: {
                        file:{
                            name: row.title,
                            uploadTime: row.createTime,
                            url: row.docUrl
                        }
                    }
                })
            },
            onCancel(){//关闭
                this.$modal.close();
            },
        }
    }
</script>

<style scoped>
    .preview{
        color:blue;
        cursor: pointer;
        margin-left: 10px;
    }
</style>
